import { React } from '@common/3rd';
import { DeskComponentRegistry } from '@component';

export * from './desk-auto-complete';
export * from './desk-button';
export * from './desk-checkbox';
export * from './desk-label';
export * from './desk-pagination';
export * from './desk-select';
export * from './desk-multiple-select';
export * from './desk-spread-sheet';
export * from './desk-text';
export * from './desk-toggle';
export * from './desk-upload';
export * from './desk-top-steps';
export * from './desk-radio';
export * from './desk-tab';
export * from './desk-table';
export * from './desk-checkbox-sets';
export * from './desk-print';
export const DeskImage = React.lazy(() => import(/* webpackChunkName: "desk-image" */ './desk-image'));
export const DeskMarkdown = React.lazy(() => import(/* webpackChunkName: "desk-markdown" */ './desk-markdown'));
export const DeskPdf = React.lazy(() => import(/* webpackChunkName: "desk-pdf" */ './desk-pdf'));

DeskComponentRegistry.register({
	image: DeskImage,
	md: DeskMarkdown,
	pdf: DeskPdf
});
